import { ShoppingBag } from "lucide-react";
import { useCart } from "@/lib/cart";

export const CartButton = () => {
  const { count, setOpen } = useCart();
  return (
    <button data-testid="header-cart-button" onClick={() => setOpen(true)} aria-label={`Abrir carrinho (${count} itens)`} title="Carrinho"
      className="relative flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white transition-colors hover:bg-white/10">
      <ShoppingBag className="h-4 w-4" />
      {count > 0 && (
        <span data-testid="header-cart-count" className="absolute -right-1 -top-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-white px-1 text-[11px] font-bold text-black">
          {count}
        </span>
      )}
    </button>
  );
};
